/* eslint-env browser */
import React from 'react';
import UseGoogleMapsLoader from '../hooks/UseGoogleMapsLoader';

const WithGoogleMapsLoader = (WrappedComponent) => (props) => {
  let lang = 'da';
  if (typeof window.appLang !== 'undefined') {
    lang = window.appLang;
  } else if (typeof window.pageLang === 'undefined') {
    lang = document.querySelector('html').getAttribute('lang') || 'da';
  }

  const isGoogleMapsLoaded = UseGoogleMapsLoader(lang);

  if (!isGoogleMapsLoaded) {
    return <div>Loading Google Maps...</div>;
  }

  /* eslint-disable react/jsx-props-no-spreading */
  return <WrappedComponent {...props} />;
};

export default WithGoogleMapsLoader;
